import React, { Component } from 'react';
import styled from 'styled-components';
import PropTypes from 'prop-types';

class Button extends Component {
  static propTypes = {
    label: PropTypes.string.isRequired,
    onClick: PropTypes.func,
  };

  render() {
    const { label, onClick } = this.props;
    return <Root onClick={onClick}>{label}</Root>;
  }
}

export default Button;

const Root = styled.button`
  &,
  &:after {
    -webkit-transition: all 0.3s;
    -moz-transition: all 0.3s;
    -o-transition: all 0.3s;
    transition: all 0.3s;
  }
  background: none;
  width: 233px;
  height: 62px;
  border: 1px solid #f57f29;
  border-radius: 4px;
  font-family: 'korolev';
  font-style: normal;
  font-weight: 500;
  font-size: 16px;
  color: #f57f29;
  letter-spacing: 1px;
  position: relative;
  cursor: pointer;
  z-index: 99;
  &:before,
  &:after {
    background: #f57f29;
    content: '';
    position: absolute;
    z-index: -1;
  }
  &:hover {
    color: white;
  }
  &:hover:after {
    width: 100%;
  }
  &:after {
    height: 100%;
    left: 0;
    top: 0;
    width: 0;
  }
`;



// WEBPACK FOOTER //
// ./src/components/Button.js